/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Affiliates_TitleInputs */

const en_directory_resources_affiliates_title = /** @type {(inputs: Directory_Resources_Affiliates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommend products people can discover`)
};

const zh_directory_resources_affiliates_title = /** @type {(inputs: Directory_Resources_Affiliates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐值得被发现的产品`)
};

/**
* | output |
* | --- |
* | "Recommend products people can discover" |
*
* @param {Directory_Resources_Affiliates_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_affiliates_title = /** @type {((inputs?: Directory_Resources_Affiliates_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Affiliates_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_affiliates_title(inputs)
	return zh_directory_resources_affiliates_title(inputs)
});
export { directory_resources_affiliates_title as "directory.resources.affiliates.title" }